import { SearchGPTMessage } from "../GPTConvoTypes";
import CreateRecordMessage from "./CreateRecordMessage";
import GeneralMessage from "./GeneralMessage";
import NavigateMessage from "./NavigateMessage";
import SearchMessage from "./SearchMessage";
import SortMessage from "./SortMessage";

interface Props {
  message: SearchGPTMessage;
}

export default function BrieResponseMessage({ message }: Props) {
  if (!message) return "Sorry, something went wrong.";

  if (message.Type === "Search") {
    return <SearchMessage message={message} />;
  }

  if (message.Type === "Sort") {
    return <SortMessage message={message} />;
  }

  if (message.Type === "Create Record") {
    return <CreateRecordMessage message={message} />;
  }

  if (message.Type === "Navigate") {
    return <NavigateMessage message={message} />;
  }

  if (message.Type === "General Request") {
    return <GeneralMessage message={message} />;
  }

  return <div className="p-2">{message?.Message}</div>;
}
